import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M5.954 16a1.697 1.697 0 0 1-1.332-.632L.34 9.972a1.561 1.561 0 0 1-.285-.559A1.519 1.519 0 0 1 .23 8.206c.111-.18.258-.338.433-.464a1.748 1.748 0 0 1 1.854-.105c.19.106.356.247.488.414l2.818 3.547L12.91.75c.235-.358.61-.612 1.041-.708a1.743 1.743 0 0 1 1.262.2c.783.464 1.024 1.447.535 2.194L7.374 15.248c-.143.22-.34.403-.574.533-.234.131-.498.205-.769.217-.026.002-.05.002-.077.002Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
